import React from 'react';

function auto_grow(element: any) {
  element.style.height = '5px';
  element.style.height = element.scrollHeight + 'px';
}

export const CustomTextarea = React.forwardRef<HTMLTextAreaElement>(
  (props, ref) => {
    return (
      <textarea
        ref={ref}
        rows={1}
        onInput={(event) => auto_grow(event.target)}
        {...props}
      />
    );
  },
);

CustomTextarea.displayName = 'CustomTextarea';
